// extracted by mini-css-extract-plugin
export default {"mainContainer":"Header_mainContainer__XhpQM","logo":"Header_logo__uTM2S"};